import * as Sentry from '@sentry/react';

const sentryEnvironment = import.meta.env.REACT_APP_SENTRY_ENVIRONMENT ?? 'local';

const sentry: Sentry.BrowserOptions = {
	enabled: import.meta.env.REACT_APP_SENTRY_DSN != null,
	dsn: import.meta.env.REACT_APP_SENTRY_DSN,
	debug: sentryEnvironment === 'local',
	environment: sentryEnvironment,
	release: import.meta.env.REACT_APP_SENTRY_RELEASE,
	integrations: [
		Sentry.extraErrorDataIntegration(),
		Sentry.captureConsoleIntegration({
			levels: ['warn', 'error', 'assert'],
		}),
		Sentry.browserTracingIntegration(),
	],
};

const config = {
	environment: import.meta.env.REACT_APP_ENVIRONMENT ?? 'local',
	sentry,

	apigw: {
		base: import.meta.env.REACT_APP_APIGW_BASE ?? 'http://localhost:43210/project',
	},

	contember: {
		loginToken: import.meta.env.REACT_APP_CONTEMBER_LOGIN_TOKEN ?? '1111111111111111111111111111111111111111',
	},

	organization: {
		fallback: import.meta.env.REACT_APP_ORGANIZATION_FALLBACK ?? 'default',
		domainRegex: new RegExp(
			import.meta.env.REACT_APP_ORGANIZATION_DOMAIN_REGEXP ?? '^(?<slug>[^.]+)\\.(?:(?:rc\\.)?(?:outofdark\\.(?:site))|localhost)$',
		),
	},

	minPasswordLength: parseInt(import.meta.env.REACT_APP_MIN_PASSWORD_LENGTH ?? '6', 10),

	google: {
		clientId: import.meta.env.REACT_APP_GOOGLE_CLIENT_ID ?? '939399702113-ffc9p93f0ul3kmsacgdbija6nmpj9tgk.apps.googleusercontent.com',
		apiKey: import.meta.env.REACT_APP_GOOGLE_API_KEY ?? 'AIzaSyBPfyDzFGrAU7NMlBnHDo6_1AyuiUk3RPQ',
		redirectUri: import.meta.env.REACT_APP_GOOGLE_REDIRECT_URI ?? 'http://localhost:3002',
	},

	defaultTimeout: parseInt(import.meta.env.REACT_APP_DEFAULT_TIMEOUT ?? '250', 10),

	templateIds: {
		empty: 'cfb116b5-539d-4b8a-a965-3d476c00f14a',
		recommended: ['cfb116b5-539d-4b8a-a965-3d476c00f14a', 'd5ee16a9-56e9-4e38-af19-695daca9c069', '22cf1da3-e59d-47ac-9b5c-aa140b5515c8'],
	},

	dashboardId: 'f435cb82-ce99-4e3f-9464-9f02c2cac1f7',
} as const;

export default config;
